// extracted by mini-css-extract-plugin
module.exports = {"container":"TooltipPricesHistory_container__Y4d67","tooltip":"TooltipPricesHistory_tooltip__u06yf","icon":"TooltipPricesHistory_icon__IUotv"};